import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import { IMLPackage } from '@models';
import {
    GRID_SERVICE,
    ODataGridComponent,
} from '@pages/generics/grid';
import {
    MLPackagesService,
    ModalService,
} from '@services';

import cloneDeep from 'lodash-es/cloneDeep';

import {
    MLPackageUploadModalComponent,
    MLPackageVersionsModalComponent,
} from './modals';

@Component({
    templateUrl: './mlpackages.page.html',
    providers: [{
        provide: GRID_SERVICE,
        useClass: MLPackagesService,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MLPackagesPageComponent extends ODataGridComponent<IMLPackage, string> {

    private _modalService = this._injector.get<ModalService>(ModalService);

    public uploadModelVersion(model?: IMLPackage) {
        const clone = cloneDeep(model);

        this._modalService
            .openModal(MLPackageUploadModalComponent, clone)
            .afterClosedResult()
            .subscribe(_ => this._refresh$.next());
    }

    public showMLPackageVersions(model?: IMLPackage) {
        const clone = cloneDeep(model);

        this._modalService
            .openModal(MLPackageVersionsModalComponent, clone)
            .afterClosedResult()
            .subscribe(_ => this._refresh$.next());
    }
}
